<template>
    <div>
        <div>
            <div class="block font-semibold text-gray-700 mb-2 text-left">
                <svg class="inline w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                Name on Card
            </div>

            <div class="flex -space-x-px">
                <div class="w-1/2 flex-1 min-w-0 pr-1">
                    <input :value="$attrs['first_name']"
                        :class="{ [`focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 border-gray-300`]: ! error, 'focus:ring-red-400 focus:border-red-400 border-red-300': error }"
                        @input="$emit('update:first_name', $event.target.value)"
                        type="text"
                        :name="`first_name_${unique}`"
                        :id="`first_name`"
                        class="py-3 px-4 rounded bg-gray-50 relative block w-full bg-transparent focus:z-10 sm:text-sm"
                        placeholder="First Name"
                        :required="true">
                </div>
                <div class="flex-1 min-w-0 pl-1">
                    <input :value="$attrs['last_name']"
                        :class="{ [`focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 border-gray-300`]: ! error, 'focus:ring-red-400 focus:border-red-400 border-red-300': error }"
                        @input="$emit('update:last_name', $event.target.value)"
                        type="text"
                        :name="`last_name_${unique}`"
                        :id="`last_name`"
                        class="py-3 px-4 rounded bg-gray-50 relative block w-full bg-transparent focus:z-10 sm:text-sm"
                        placeholder="Last Name"
                        :required="true">
                </div>
            </div>
        </div>

        <div v-if="settings.hasOwnProperty('collect_address') && settings.collect_address" class="mt-4">
            <div class="block font-semibold text-gray-700 mb-2 text-left">
                Address
            </div>

            <div class="flex -space-x-px">
                <div class="w-1/2 flex-1 min-w-0 pr-1">
                    <input :value="$attrs['address']"
                           :class="{ [`focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 border-gray-300`]: ! error, 'focus:ring-red-400 focus:border-red-400 border-red-300': error }"
                           @input="$emit('update:address', $event.target.value)"
                           type="text"
                           :name="`address_${unique}`"
                           :id="`address`"
                           class="py-3 px-4 rounded bg-gray-50 relative block w-full bg-transparent focus:z-10 sm:text-sm"
                           placeholder="Address"
                           :required="true">
                </div>
            </div>
        </div>

        <div v-if="settings.hasOwnProperty('collect_address') && settings.collect_address" class="mt-4">
            <div class="block font-semibold text-gray-700 mb-2 text-left">
                City
            </div>

            <div class="flex -space-x-px">
                <div class="w-1/2 flex-1 min-w-0 pr-1">
                    <input :value="$attrs['city']"
                           :class="{ [`focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 border-gray-300`]: ! error, 'focus:ring-red-400 focus:border-red-400 border-red-300': error }"
                           @input="$emit('update:city', $event.target.value)"
                           type="text"
                           :name="`city_${unique}`"
                           :id="`city`"
                           class="py-3 px-4 rounded bg-gray-50 relative block w-full bg-transparent focus:z-10 sm:text-sm"
                           placeholder="City"
                           :required="true">
                </div>
            </div>
        </div>


        <div v-if="settings.hasOwnProperty('collect_address') && settings.collect_address" class="mt-4">
            <div class="flex -space-x-px">
                <div class="w-1/2 flex-1 min-w-0 pr-1">
                    <div class="block font-semibold text-gray-700 mb-2 text-left">
                        State
                    </div>
                    <select class="py-3 px-4 rounded bg-gray-50 relative block w-full bg-transparent focus:z-10 sm:text-sm"
                        :class="{ [`focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 border-gray-300`]: ! error, 'focus:ring-red-400 focus:border-red-400 border-red-300': error }"
                        :name="`state_${unique}`"
                        :id="`state`"
                        :required="true"
                        @change="$emit('update:state', $event.target.value)">
                        <option value="null">Choose One</option>
                        <option v-for="(state, abbr) in $root.states" :value="abbr" :checked="$attrs['state']">{{ state | ucfirst }}</option>
                    </select>
                </div>
                <div class="flex-1 min-w-0 pl-1">
                    <div class="block font-semibold text-gray-700 mb-2 text-left">
                        Zip Code
                    </div>
                    <input :value="$attrs['zip']"
                           :class="{ [`focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 border-gray-300`]: ! error, 'focus:ring-red-400 focus:border-red-400 border-red-300': error }"
                           @keyup="validateNumber($event.target.value, 'zip')"
                           :ref="`zip_${unique}`"
                           maxlength="5"
                           type="text"
                           :name="`zip_${unique}`"
                           :id="`zip`"
                           class="py-3 px-4 rounded bg-gray-50 relative block w-full bg-transparent focus:z-10 sm:text-sm"
                           placeholder="Zip Code"
                           :required="true">
                </div>
            </div>
        </div>

        <div class="mt-4">
            <div class="flex items-center justify-between">
                <label :for="`card_number_${unique}`" class="block font-semibold text-gray-700 mb-2 text-left">
                    Card Number
                </label>
                <label v-if="! ccValidStatus" class="block font-semibold text-red-700 mb-2 text-xs">
                    Invalid Card Number
                </label>
            </div>
            <input
                :class="{ [`focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 border-gray-300`]: ! error, 'focus:ring-red-400 focus:border-red-400 border-red-300': error }"
                :value="$attrs['cc_number']"
                @keyup="validateNumber($event.target.value, 'cc_number')"
                :ref="`cc_number_${unique}`"
                maxlength="16"
                type="text"
                :name="`card_number_${unique}`"
                :id="`card_number`"
                class="py-3 px-4 rounded bg-gray-50 relative block w-full bg-transparent focus:z-10 sm:text-sm"
                placeholder="Card Number"
                :required="true">
        </div>

        <div class="mt-4">
            <div class="flex -space-x-px">
                <div class="w-1/2 flex-1 min-w-0 pr-1">
                    <label :for="`card_exp_${unique}`" class="block font-semibold text-gray-700 mb-2 text-left">
                        Expiration
                    </label>
                    <input :value="$attrs['card_exp']"
                        :class="{ [`focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 border-gray-300`]: ! error, 'focus:ring-red-400 focus:border-red-400 border-red-300': error }"
                        @keyup="populateCardExpiration($event.target.value)"
                        @blur="checkCardExpirationOnBlur($event.target.value)"
                        maxlength="5"
                        :ref="`card_exp_${unique}`"
                        type="text"
                        :name="`card_exp_${unique}`"
                        :id="`card_exp`"
                        class="py-3 px-4 rounded bg-gray-50 relative block w-full bg-transparent focus:z-10 sm:text-sm"
                        placeholder="MM/YY"
                        :required="true">
                </div>
                <div class="flex-1 min-w-0 pl-1">
                    <label :for="`cvv_${unique}`" class="block font-semibold text-gray-700 mb-2 text-left">
                        CVV <a href="#" @click.prevent="$root.$refs.app.showingModal.cvv = true"><i class="fa fa-info-circle fa-fw"></i></a>
                    </label>
                    <input :value="$attrs['cvv']"
                        :class="{ [`focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 border-gray-300`]: ! error, 'focus:ring-red-400 focus:border-red-400 border-red-300': error }"
                        @keyup="validateNumber($event.target.value, 'cvv')"
                        :ref="`cvv_${unique}`"
                        maxlength="4"
                        type="text"
                        :name="`cvv_${unique}`"
                        :id="`cvv`"
                        class="py-3 px-4 rounded bg-gray-50 relative block w-full bg-transparent focus:z-10 sm:text-sm"
                        placeholder="CVV"
                        :required="true">
                </div>
            </div>
        </div>

        <div v-if="! settings.hasOwnProperty('collect_address') || ! settings.collect_address" class="mt-4">
            <label :for="`zip_${unique}`" class="block font-semibold text-gray-700 mb-2 text-left">
                Zip Code
            </label>
            <input :value="$attrs['zip']"
                :class="{ [`focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 border-gray-300`]: ! error, 'focus:ring-red-400 focus:border-red-400 border-red-300': error }"
                @keyup="validateNumber($event.target.value, 'zip')"
                :ref="`zip_${unique}`"
                maxlength="5"
                type="text"
                :name="`zip_${unique}`"
                :id="`zip`"
                class="py-3 px-4 rounded bg-gray-50 relative block w-full bg-transparent focus:z-10 sm:text-sm"
                placeholder="Zip Code"
                :required="true">
        </div>
    </div>
</template>

<script>
    export default {
        props: ['error', 'settings', 'states', 'cc-valid-status'],

        created() {
            this.unique = Math.floor(Math.random() * 100);
        },

        data() {
            return {
                unique: null
            }
        },

        methods: {
            /**
             * @param cardExpiration
             * @returns {void}
             */
            populateCardExpiration(cardExpiration) {
                cardExpiration.match(/(\D*)\d*\/*\d*(.*)/)
                    .slice(1)
                    .filter(i => !! i)
                    .forEach(match => cardExpiration = cardExpiration.replaceAll(match, ''));

                this.$refs[`card_exp_${this.unique}`].value = cardExpiration;

                if (! cardExpiration.includes('/') && cardExpiration.length >= 4) {
                    let month = cardExpiration.slice(0, 2),
                        year = cardExpiration.slice(2);

                    this.$emit('update:exp_month', month);
                    this.$emit('update:exp_year', year);

                    cardExpiration = [month, year].join('/');
                }

                this.$emit('update:card_exp', cardExpiration);
            },

            /**
             * @param cardExpiration
             * @returns {void}
             */
            checkCardExpirationOnBlur(cardExpiration) {
                cardExpiration.match(/(\D*)\d*\/*\d*(.*)/)
                    .slice(1)
                    .filter(i => !! i)
                    .forEach(match => cardExpiration = cardExpiration.replaceAll(match, ''));

                this.$refs[`card_exp_${this.unique}`].value = cardExpiration;

                if (! cardExpiration.includes('/') && cardExpiration.length === 3) {
                    let month = `0${cardExpiration.slice(0, 1)}`,
                        year = cardExpiration.slice(1);

                    this.$emit('update:exp_month', month);
                    this.$emit('update:exp_year', year);

                    cardExpiration = [month, year].join('/');
                }

                this.$emit('update:card_exp', cardExpiration);
            },

            validateNumber(valueToValidate, fieldName) {
                valueToValidate.match(/(\D*)\d*\/*\d*(.*)/)
                    .slice(1)
                    .filter(i => !! i)
                    .forEach(match => valueToValidate = valueToValidate.replaceAll(match, ''));

                this.$refs[`${fieldName}_${this.unique}`].value = valueToValidate;
                this.$emit(`update:${fieldName}`, valueToValidate);
            }
        }
    }
</script>
